import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  booking: {},
  selectedPassenger: "1 Passenger",
  selectdCurrency: "USD",
  sourceLatLan: "",
  destinationLatLan: "",
  postalCodeSource: "",
  postalCodeDestination: "",
  bookingDetailsById: {},
  timeDetails: {},
  timezone: "",
  dateTimeIST: {},
  matchingRegion: {},
  isSearhingCar: false,
  distance: undefined,
  sourceWithRegion: undefined,
  destinationWithRegion: undefined,
  allBookings: [],
  currencyprice: {},
  bookingInitiateLoading: false,
  groupBooking: {},
  search: {
    bookingId: null,
    createdDateStart: null,
    createdDateEnd: null,
    travelStartDate: null,
    travelEndDate: null,
    companyName: null,
    userName: null,
    affiliateName: null,
    affiliateNumber: null,
    passengerName: null,
    passengerNumber: null,
    driverName: null,
    driverNumber: null,
    bookingStatus: null,
    paymentStatus: null,
    invoiceNumber: null,
    invoicedStatus: null,
    groupId: null,
    quoteby: null,
  },
  currencydropdown: false,
  airPorts: [],
  uploadingInvoiceStatus: false,
  convertedPrice: undefined,
  pageCount: 1,
  checkSourceRegion: false,
  checkDestinationRegion: false,
  searchResultScreen: false,
  dateChange: "",
  flightData: {},
  flightArrivalDepartureData: {},
  flightArrivalDepartureErrorData: "",
  allSearchedBookings: [],
  totalBookingCount: "",
  searchedBookingCount: "",
  paginatedBookingCount: "",
  flightLoading: false,
  bookingDuration: "",
  bookingIsloading: true,
  singleBookingDetailLoading: true,
  isSearchingPrice: false,
  jobsForTodayBookings: [],
  jobsForTomorrowBookings: [],
  unassignedJobs: [],
  affiliatePaymentPendingBookings: [],
  totalTomorrowBookingsCount: "",
  paginatedTomorrowBookingsCount: "",
  totalTodayBookingsCount: "",
  paginatedTodayBookingsCount: "",
  totalunassignedBookingsCount: "",
  paginatedunassignedBookingsCount: "",
  jobsTab: {
    allBookings: true,
    jobsToday: false,
    jobsTomorrow: false,
    unassignedJobs: false,
    inprogressJobs: false,
    paymentPending: false,
  },
  groupIds: [],
  pobBookings: [],
  editBookingError: "",
  editBookingDate: "",
  editBookingTime: "",
  editBookingLoading: false,
  editBookingAllowed: true,
  quotedBy: "",

  allAmmendments :[],
  ammendmentCount :"",
  ammendmentDataLoading:false,

  allFinanceAmmendments :[],
  ammendmentFinanceCount :"",
  ammendmentFinanceDataLoading:false,
  allOpsAmmendments :[],
  ammendmentOpsCount :"",
  ammendmentOpsDataLoading:false,
  multiCloneBookingLoading:false
};

const bookingSlice = createSlice({
  name: "booking",
  initialState: initialState,
  reducers: {
    setGeneratedBookingGroupID: (state, action) => {
      state.generatedBookingGroupID = action.payload.generatedBookingGroupID;
      console.log(
        "generatedBookingGroupID state",
        state.generatedBookingGroupID
      );
    },
    setaffiliatePaymentPendingBookings: (state, action) => {
      state.affiliatePaymentPendingBookings =
        action.payload.affiliatePaymentPendingBookings;
    },
    setPobBookings: (state, action) => {
      state.pobBookings = action.payload.pobBookings;
    },
    setBookingInitiateLoading: (state, action) => {
      state.bookingInitiateLoading = action.payload.bookingInitiateLoading;
    },
    setPostalCodeSource: (state, action) => {
      state.postalCodeSource = action.payload.postalCodeSource;
    },
    setPostalCodeDestination: (state, action) => {
      state.postalCodeDestination = action.payload.postalCodeDestination;
    },
    setisSearchingprice: (state, action) => {
      state.isSearchingPrice = action.payload.isSearchingPrice;
    },
    setCurrencyPrice: (state, action) => {
      state.currencyprice = action.payload.currencyprice;
    },
    setFlightArrivalDepartureErrorData(state, action) {
      state.flightArrivalDepartureErrorData =
        action.payload.flightArrivalDepartureErrorData;
    },
    setFlightArrivalDepartureData(state, action) {
      state.flightArrivalDepartureData =
        action.payload.flightArrivalDepartureData;
    },
    setSingleBookingDetailLoading: (state, action) => {
      state.singleBookingDetailLoading =
        action.payload.singleBookingDetailLoading;
    },
    setIsBookingLoading: (state, action) => {
      state.bookingIsloading = action.payload.bookingIsloading;
    },
    setJobsForTodayBookings: (state, action) => {
      state.jobsForTodayBookings = action.payload.jobsForTodayBookings;
    },
    setJobsForTomorrowBookings: (state, action) => {
      state.jobsForTomorrowBookings = action.payload.jobsForTomorrowBookings;
    },
    setUnassignedJobs: (state, action) => {
      state.unassignedJobs = action.payload.unassignedJobs;
    },
    setJobsTab: (state, action) => {
      state.jobsTab = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
    },
    setFlightLoading(state, action) {
      state.flightLoading = action.payload.flightLoading;
    },
    setFlightData(state, action) {
      state.flightData = action.payload.flightData;
    },
    setBookingDateChange(state, action) {
      state.dateChange = action.payload.dateChange;
    },
    setSearchResultScreen(state, action) {
      state.searchResultScreen = action.payload.searchResultScreen;
    },
    setSourceRegionCheck: (state, action) => {
      state.checkSourceRegion = action.payload.checkSourceRegion;
    },
    setDestinationRegionCheck: (state, action) => {
      state.checkDestinationRegion = action.payload.checkDestinationRegion;
    },
    setPageNext(state, action) {
      state.pageCount = state.pageCount + 1;
    },
    setPagePrev(state, action) {
      state.pageCount = state.pageCount - 1;
    },
    setPageCount(state, action) {
      state.pageCount = action.payload.pageCount;
    },
    setConvertedPrice: (state, action) => {
      state.convertedPrice = action.payload.convertedPrice;
    },
    setBookingDetails: (state, action) => {
      state.booking = action.payload.booking;
    },
    setBookingDetailsById: (state, action) => {
      state.bookingDetailsById = action.payload.bookingDetailsById;
    },
    selectPassenger: (state, action) => {
      state.selectedPassenger = action.payload.selectedPassenger;
    },
    clearPassenger: (state) => {
      state.selectedPassenger = "";
    },
    setCurrency: (state, action) => {
      state.selectdCurrency = action.payload.selectdCurrency;
    },
    clearCurrency: (state) => {
      state.selectdCurrency = "";
    },
    getLatLanOfSource: (state, action) => {
      state.sourceLatLan = action.payload.sourceLatLan;
    },
    getLatLanOfDestination: (state, action) => {
      state.destinationLatLan = action.payload.destinationLatLan;
    },
    getTimeDetails: (state, action) => {
      state.timeDetails = action.payload.timeDetails;

      state.timezone = state.timeDetails.timezone_location;
    },
    getDateTimeDetailIST: (state, action) => {
      state.dateTimeIST = action.payload.dateTimeIST;
    },
    getMatchingRegion: (state, action) => {
      state.matchingRegion = action.payload.matchingRegion;
    },
    searchingCarsWaiting: (state, action) => {
      state.isSearhingCar = action.payload.isSearhingCar;
    },
    getDistanceInKm: (state, action) => {
      state.distance = action.payload.distance;
    },
    getDuration: (state, action) => {
      state.bookingDuration = action.payload.bookingDuration;
    },
    getSourceWithRegion: (state, action) => {
      state.sourceWithRegion = action.payload.sourceWithRegion;
    },
    getDestinationWithRegion: (state, action) => {
      state.destinationWithRegion = action.payload.destinationWithRegion;
    },
    getAllbookings: (state, action) => {
      state.allBookings = action.payload.allBookings;
    },
    getAllSearchedbookings: (state, action) => {
      state.allSearchedBookings = action.payload.allSearchedBookings;
    },
    getAirports: (state, action) => {
      state.airPorts = action.payload.airPorts;
    },
    setUploading: (state, action) => {
      state.uploadingInvoiceStatus = action.payload.uploadingInvoiceStatus;
    },
    setTotalBookingCount: (state, action) => {
      state.totalBookingCount = action.payload.totalBookingCount;
    },
    setSearchedBookingCount: (state, action) => {
      state.searchedBookingCount = action.payload.searchedBookingCount;
    },
    setPaginatedBookingCount: (state, action) => {
      state.paginatedBookingCount = action.payload.paginatedBookingCount;
    },
    setDropDownOpen: (state, action) => {
      state.currencydropdown = action.payload.currencydropdown;
    },
    setGroupBooking: (state, action) => {
      state.groupBooking = action.payload;
    },
    getgroupIds: (state, action) => {
      state.groupIds = action.payload;
    },
    setPaginatedTodayBookingCount: (state, action) => {
      state.paginatedTodayBookingsCount =
        action.payload.paginatedTodayBookingsCount;
    },
    setTotalTodayBookingCount: (state, action) => {
      state.totalTodayBookingsCount = action.payload.totalTodayBookingsCount;
    },
    setPaginatedTomorrowBookingCount: (state, action) => {
      state.paginatedTomorrowBookingsCount =
        action.payload.paginatedTomorrowBookingsCount;
    },
    setTotalTomorrowBookingCount: (state, action) => {
      state.totalTomorrowBookingsCount =
        action.payload.totalTomorrowBookingsCount;
    },
    setPaginatedunassignedBookingCount: (state, action) => {
      state.paginatedunassignedBookingsCount =
        action.payload.paginatedunassignedBookingsCount;
    },
    setTotalunassignedBookingCount: (state, action) => {
      state.totalunassignedBookingsCount =
        action.payload.totalunassignedBookingsCount;
      state.totalunassignedBookingsCount =
        action.payload.totalunassignedBookingsCount;
    },
    setEditBookingError: (state, action) => {
      state.editBookingError = action.payload.editBookingError;
    },
    setEditBookingDate: (state, action) => {
      state.editBookingDate = action.payload.editBookingDate;
    },
    setEditBookingLoading: (state, action) => {
      state.editBookingLoading = action.payload.editBookingLoading;
    },
    setEditBookingTime: (state, action) => {
      state.editBookingTime = action.payload.editBookingTime;
    },
    setEditBookingAllowed: (state, action) => {
      state.editBookingAllowed = action.payload.editBookingAllowed;
    },
    setQuoteBy: (state, action) => {
      state.quotedBy = action.payload.quotedBy;
    },
    setAllAmmendments: (state, action) => {
      state.allAmmendments = action.payload.allAmmendments;
    },
    setAmmendmentCount: (state, action) => {
      state.ammendmentCount = action.payload.ammendmentCount;
    },
    setAmmendmentDataLoading: (state, action) => {
      state.ammendmentDataLoading = action.payload.ammendmentDataLoading;
    },

    setAllFinanceAmmendments: (state, action) => {
      state.allFinanceAmmendments = action.payload.allFinanceAmmendments;
    },
    setFinanceAmmendmentCount: (state, action) => {
      state.ammendmentFinanceCount = action.payload.ammendmentFinanceCount;
    },
    setFinanceAmmendmentDataLoading: (state, action) => {
      state.ammendmentFinanceDataLoading = action.payload.ammendmentFinanceDataLoading;
    },

    setAllOpsAmmendments: (state, action) => {
      state.allOpsAmmendments = action.payload.allOpsAmmendments;
    },
    setOpsAmmendmentCount: (state, action) => {
      state.ammendmentOpsCount = action.payload.ammendmentOpsCount;
    },
    setOpsAmmendmentDataLoading: (state, action) => {
      state.ammendmentOpsDataLoading = action.payload.ammendmentOpsDataLoading;
    },
    setMultiCloneBookingLoading: (state, action) => {
      state.multiCloneBookingLoading = action.payload.multiCloneBookingLoading;
    },
  },
});

export const {
  setaffiliatePaymentPendingBookings,
  setBookingInitiateLoading,
  setUnassignedJobs,
  setisSearchingprice,
  setFlightArrivalDepartureErrorData,
  setFlightArrivalDepartureData,
  setSingleBookingDetailLoading,
  setIsBookingLoading,
  setJobsForTodayBookings,
  setJobsForTomorrowBookings,
  setJobsTab,
  setSearch,
  setFlightLoading,
  setTotalBookingCount,
  setSearchedBookingCount,
  setPaginatedBookingCount,
  setFlightData,
  setBookingDateChange,
  setSearchResultScreen,
  setSourceRegionCheck,
  setDestinationRegionCheck,
  setPageNext,
  setPagePrev,
  setPageCount,
  setConvertedPrice,
  selectPassenger,
  clearPassenger,
  getLatLanOfDestination,
  getLatLanOfSource,
  getTimeDetails,
  setCurrency,
  clearCurrency,
  getMatchingRegion,
  searchingCarsWaiting,
  getDistanceInKm,
  getSourceWithRegion,
  getDestinationWithRegion,
  setBookingDetails,
  getAllbookings,
  getAllSearchedbookings,
  setBookingDetailsById,
  getAirports,
  setUploading,
  getDuration,
  setCurrencyPrice,
  setDropDownOpen,
  setPostalCodeDestination,
  setPostalCodeSource,
  getDateTimeDetailIST,
  getgroupIds,
  setGroupBooking,
  setPaginatedTodayBookingCount,
  setTotalTodayBookingCount,
  setPaginatedTomorrowBookingCount,
  setTotalTomorrowBookingCount,
  setPaginatedunassignedBookingCount,
  setTotalunassignedBookingCount,
  setPobBookings,
  setEditBookingError,
  setEditBookingDate,
  setEditBookingLoading,
  setEditBookingTime,
  setEditBookingAllowed,
  setQuoteBy,
  setAllAmmendments,
  setAmmendmentCount,
  setAmmendmentDataLoading,

  setAllFinanceAmmendments,
  setFinanceAmmendmentCount,
  setFinanceAmmendmentDataLoading,
  setAllOpsAmmendments,
  setOpsAmmendmentCount,
  setOpsAmmendmentDataLoading,
  setMultiCloneBookingLoading,

} = bookingSlice.actions;

export const bookingSliceReducer = bookingSlice.reducer;
